<app-loader [isBusy]="isBusy">
    <ng-template>
        <form [formGroup]="form" (ngSubmit)="save()">
            <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button class="close" type="button" aria-label="Close" (click)="activeModal.close(false)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                @if (forBulk) {
                    <div class="row">
                        <div class="col-6 mt-3">
                            <form-textbox
                                labelText="{{ 'B/L Number' | translate }}"
                                formControlName="billOfLading"></form-textbox>
                        </div>
                        <div class="col-6 mt-3">
                            <form-dropdown
                                labelText="{{ 'Loading / Discharge Port' | translate }}"
                                formControlName="loadingDischargePortId"
                                codeListName="Port"></form-dropdown>
                        </div>
                        <div class="col-6 mt-3">
                            <form-textarea
                                labelText="{{ 'Description' | translate }}"
                                formControlName="description"></form-textarea>
                        </div>
                        <div class="col-6 mt-3">
                            <form-textbox
                                labelText="{{ 'Consignee' | translate }}"
                                formControlName="consignee"></form-textbox>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Quantity' | translate }}"
                                formControlName="declaredQuantity"
                                [emptyIfZero]="true"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Quantity' | translate)
                                        : ('Loaded Quantity' | translate)
                                }}"
                                formControlName="realizedQuantity"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Weight (kg)' | translate }}"
                                formControlName="declaredWeight"
                                [emptyIfZero]="true"
                                [decimal]="true"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Weight (kg)' | translate)
                                        : ('Loaded Weight (kg)' | translate)
                                }}"
                                formControlName="realizedWeight"
                                [decimal]="true"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Volume (m3)' | translate }}"
                                formControlName="declaredVolume"
                                [emptyIfZero]="true"
                                [decimal]="true"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Volume (m³)' | translate)
                                        : ('Loaded Volume (m³)' | translate)
                                }}"
                                formControlName="realizedVolume"
                                [decimal]="true"></form-number>
                        </div>
                        @if (showWeightInVacuum) {
                            <div class="col-6 mt-3">
                                <form-number
                                    labelText="{{ 'Declared Weight in Vacuum (kg)' | translate }}"
                                    formControlName="declaredWeightInVacuum"
                                    [emptyIfZero]="true"
                                    [decimal]="true"></form-number>
                            </div>
                        }
                        @if (showWeightInVacuum) {
                            <div class="col-6 mt-3">
                                <form-number
                                    labelText="{{
                                        cargoDirectionId === 'I'
                                            ? ('Discharged Weight in Vacuum (kg)' | translate)
                                            : ('Loaded Weight in Vacuum (kg)' | translate)
                                    }}"
                                    formControlName="realizedWeightInVacuum"
                                    [decimal]="true"></form-number>
                            </div>
                        }
                    </div>
                }

                @if (forContainers) {
                    <div class="row">
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Total Containers' | translate }}"
                                formControlName="declaredTotalCont"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Total Containers' | translate)
                                        : ('Loaded Total Containers' | translate)
                                }}"
                                formControlName="realizedTotalCont"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Full 20' | translate }}"
                                formControlName="declaredFull20"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Full 20' | translate)
                                        : ('Loaded Full 20' | translate)
                                }}"
                                formControlName="realizedFull20"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Full 40' | translate }}"
                                formControlName="declaredFull40"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Full 40' | translate)
                                        : ('Loaded Full 40' | translate)
                                }}"
                                formControlName="realizedFull40"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Empty 20' | translate }}"
                                formControlName="declaredEmpty20"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Empty 20' | translate)
                                        : ('Loaded Empty 20' | translate)
                                }}"
                                formControlName="realizedEmpty20"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Empty 40' | translate }}"
                                formControlName="declaredEmpty40"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Empty 40' | translate)
                                        : ('Loaded Empty 40' | translate)
                                }}"
                                formControlName="realizedEmpty40"
                                [decimal]="false"></form-number>
                        </div>
                    </div>
                }

                @if (forRoro) {
                    <div class="row">
                        <div class="col-6 mt-3">
                            <form-dropdown
                                labelText="{{ 'Vehicle Type' | translate }}"
                                formControlName="vehicleTypeId"
                                codeListName="VehicleType"></form-dropdown>
                        </div>
                        <div class="col-6 mt-3">
                            <form-dropdown
                                labelText="{{ 'Loading / Discharge Port' | translate }}"
                                formControlName="loadingDischargePortId"
                                codeListName="Port"></form-dropdown>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{ 'Declared Vehicles' | translate }}"
                                formControlName="declaredTotalVehicles"
                                [decimal]="false"></form-number>
                        </div>
                        <div class="col-6 mt-3">
                            <form-number
                                labelText="{{
                                    cargoDirectionId === 'I'
                                        ? ('Discharged Vehicles' | translate)
                                        : ('Loaded Vehicles' | translate)
                                }}"
                                formControlName="realizedTotalVehicles"
                                [decimal]="false"></form-number>
                        </div>
                    </div>
                }

                <div class="row">
                    <div class="col mt-3">
                        <form-textarea
                            formControlName="correctionReason"
                            labelText="{{ 'Correction Reason' | translate }}"></form-textarea>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn btn-sm btn-primary mr-2" type="submit" [disabled]="!form.valid || isBusy">
                    <fa-icon [icon]="['fas', 'check']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Save' | translate }}
                </button>
                <button class="btn btn-sm btn-secondary" type="button" (click)="activeModal.close(false)">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Cancel' | translate }}
                </button>
            </div>
        </form>
    </ng-template>
</app-loader>
